import Axios from 'axios';
import {urlAPIDirectus} from "../config/Globals";

function findAll(){
    return Axios
        .get(urlAPIDirectus+"contenu?filter[status][_eq]=published")
        .then(response => response.data.data);
}
function find(id){
    return Axios
        .get(urlAPIDirectus+"contenu/"+id+"?filter[status][_eq]=published")
        .then(response => response.data.data);
}

export default {
    findAll, find
}